export const getLocale = state => state.locale

export const getFavorites = state => state.favorites

export const getUserList = state => state.userList

export const getAgvUUID = state => state.agvUUID

export const getFlow = state => state.flowList

export const getName = state => state.name
export const getEmail = state => state.email
export const getIdentity = state => state.identity

export const getTasks = state => state.tasks

export const getPushRegistered = state => state.pushRegistered
export const getMessages = state => state.messages


// WEBPACK FOOTER //
// ./src/store/getters.js